import Vue from 'vue'
import api from '@/http/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/utils/inject'
import 'normalize.css/normalize.css' // normalize css
import '@/styles/element-variables.scss'

import _ from 'lodash'
Vue.prototype._ = _
import '@/directive/action'
import VueStorage from 'vue-ls'

Vue.use(VueStorage, {
  namespace: 'megrez-',
  name: 'ls',
  storage: 'local',
})

import dragDialog from '@/directive/drag'

Vue.use(dragDialog)

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$GetCarType = (type) => {
  return `https://sm-megrez-prd.oss-cn-hangzhou.aliyuncs.com/1/assetsFiles/CarType/${type || 'Car'}.png`
}

Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

Vue.use(api)

import pageCon from '@/components/pageCon'
Vue.component('page-con', pageCon)

import pageCpn from '@/components/pageCpn'
Vue.component('page-cpn', pageCpn)

import searchGroup from '@/components/searchGroup'
Vue.component('search-group', searchGroup)
